export const ComponentNames = Object.freeze({
  Analytics: 'Analytics',
  Flows: 'Flows',
  Data: 'Data',
  Dashboard: 'Dashboard',
  NLP: 'Training',
  Support: 'Support',
  Broadcasts: 'Broadcasts',
  Widget: 'Widget',
  BotSettings: 'Settings',
})
